// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__B9ujL","fade-in":"Cart_fade-in__jZN6a","dropdown":"Cart_dropdown__ZFqA5"};